export default __webpack_public_path__ + "static/health-claims-telehealth-4172ac543d6ff7a29e592a9f2da0fb63.png";